import UI from './utils/UI'
import closest from './utils/closest'
import toggleClass from './utils/toggleClass'

UI({
  component: '.js-contactForm',
  inputs: ['.js-contactForm-input'],
  button: '.js-button',
  honeypotField: '.js-ContactForm-fieldInput',
  nonceField: '#email_field',
  toggleComplaint: '.js-contactForm-toggleComplaint',
  upload: '.js-contactForm-upload',
  fileInputText: '.js-contactForm-fileInputText',
  complaintFields: ['.js-contactForm-complaintField'],
  message: '.js-contactForm-message',
  notify: '.js-notify'
}, ui => {
  const origPlaceholder = ui.message.getAttribute('placeholder')
  const state = { uploadFile: null }
  const originalInputText = ui.fileInputText.textContent
  const busy = false
  ui.inputs.forEach(input => input.addEventListener('blur', evt => setValidationClass(evt.target), false))
  ui.upload.addEventListener('change', evt => handleUploadChange(evt, state, ui, originalInputText))
  ui.component.addEventListener('submit', evt => handleSubmit(evt, busy, ui, state), false)
  ui.toggleComplaint.addEventListener('change', evt => toggleComplaint(evt, origPlaceholder, ui))
})

function handleSubmit (evt, busy, ui, state) {
  evt.preventDefault()
  ui.button.blur()

  if (isAllValid(ui.inputs) && !busy) {
    busy = true
    ui.button.classList.add('is-busy')
    postForm(ui, state, busy)
  } else {
    ui.inputs.forEach(setValidationClass)
  }
}

function postForm ({ inputs, button, notify, honeypotField, nonceField }, state, busy) {
  const args = {
    method: 'POST',
    credentials: 'same-origin',
    body: formatData(inputs, state, honeypotField, nonceField)
  }

  fetch('/wp-admin/admin-ajax.php?action=contact_mailer', args)
    .then(res => res.json())
    .then(res => handleResponse(res, button, notify, res.success, _ => {
      busy = false
      window.dataLayer.push({ event: 'contactFormSubmitted' })
    }))
    .catch(err => handleResponse(err, button, notify, false, _ => (busy = false)))
}

function handleResponse (res, button, notify, isValid, cb) {
  button.classList.remove('is-busy')
  button.classList.add('is-send')
  notify.textContent = res.data.message
  toggleClass(notify, 'is-error', !isValid)
  cb()
}

function formatData (inputs, state, honeypotField, nonceField) {
  const data = new FormData()

  if (state.uploadFile) data.append('uploadFile', state.uploadFile)
  inputs.forEach(input => {
    if ((input.type !== 'checkbox' || input.checked) && input.type !== 'file') {
      data.append(input.getAttribute('name'), input.value)
    }
  })

  // nonce and honeypot
  data.append(nonceField.getAttribute('name'), nonceField.value)
  data.append(honeypotField.getAttribute('name'), honeypotField.value)

  return data
}

function isAllValid (inputs) {
  return inputs.map(input => input.checkValidity()).filter(Boolean).length === inputs.length
}

function setValidationClass (input) {
  const label = closest(input, el => el.tagName.toLowerCase() === 'label')
  label.classList.add('is-touched')
  toggleClass(label, 'is-invalid', !input.checkValidity())
}

function toggleComplaint(evt, origPlaceholder, ui) {
  const messagePlaceholder = evt.currentTarget.checked ? ui.message.dataset.l10nMessagePlaceholder : origPlaceholder
  ui.message.setAttribute('placeholder', messagePlaceholder)
  ui.complaintFields.forEach(field => toggleClass(field, 'is-hidden', !evt.currentTarget.checked))
}

function handleUploadChange(evt, state, ui, originalInputText) {
  state.uploadFile = null
  const file = ui.upload.files[0]
  if (file) {
    state.uploadFile = file
    showUploadResult(file.name, ui)
  } else {
    showUploadResult(originalInputText, ui)
  }
}

function showUploadResult(text, ui) {
  ui.fileInputText.textContent = text
}
